import { ExtendedProjectPhase, ExtendedPropertyType } from '@bpd-library/utilities';

export const projectPhaseDefaultFilter = ({
    mainImage,
    status,
    propertyTypes,
}: ExtendedProjectPhase) =>
    !!mainImage?.url &&
    (status === 'InPreparation' || status === 'OnSale') &&
    !!propertyTypes?.length;

export const propertyTypeDefaultFilter = ({ mainImage }: ExtendedPropertyType) => !!mainImage;
